import React from 'react';
export function WhySection() {
  return <section className="bg-ice px-4 py-5 sm:px-6" data-id="element-166" data-mp="h56iq6gptrl6">
      <div className="mx-auto max-w-2xl space-y-3" data-id="element-167" data-mp="13uqgu53jf7pz">
        <article className="rounded-xl border border-turq/30 bg-white p-3.5 shadow-sm" data-id="element-168" data-mp="13t6z0a28gom3">
          <h2 className="font-heading text-base font-extrabold uppercase leading-tight text-deep sm:text-2xl" data-id="element-169" data-mp="18t1pwdm0de75">
            What if your ophthalmology study tools were already ready?
          </h2>
          <p className="mt-1.5 text-[0.86rem] leading-snug text-muted sm:text-base" data-id="element-170" data-mp="1ijmoi11omiq2">
            You already know how important ophthalmic imaging is. The problem is
            having to constantly connect OCT scans, fundus findings, optic nerve
            patterns, visual fields and corneal maps. What exactly am I looking
            at? What visual pattern should I recognize? What should I compare
            with another image? Instead of relying on scattered references and
            isolated images, OPHTHALMOLOGY VISUAL ATLAS™ gives you visual
            resources covering 6 essential areas of ophthalmic pattern
            recognition.
          </p>
          <p className="mt-1.5 font-heading text-[0.8rem] font-bold uppercase text-turq" data-id="element-171" data-mp="2doog2jffoaj4">
            Observe. Compare. Connect. Recognize.
          </p>
        </article>

        <article className="rounded-xl border border-turq/30 bg-white p-3.5 shadow-sm" data-id="element-172" data-mp="24oi97ge8q8sx">
          <h2 className="font-heading text-base font-extrabold uppercase leading-tight text-deep sm:text-2xl" data-id="element-173" data-mp="31eiuh5fei75h">
            😩 Stop studying every ophthalmic pattern from scratch
          </h2>
          <p className="mt-1.5 text-[0.86rem] leading-snug text-muted sm:text-base" data-id="element-174" data-mp="2wdlff1pott87">
            Your time should be spent recognizing patterns — not searching
            through disconnected images and references every day.
            OPHTHALMOLOGY VISUAL ATLAS™ brings everything together. OCT
            patterns • Fundus findings • Optic nerve • Visual fields • Corneal
            imaging • Multimodal integration Everything is organized so you can
            find the right reference, review it and understand the visual
            pattern.
          </p>
          <p className="mt-1.5 font-heading text-[0.8rem] font-bold uppercase text-turq" data-id="element-175" data-mp="1ifb5eph7oo68">
            Less searching. More visual recognition.
          </p>
        </article>

        <article className="rounded-xl bg-clinical p-3.5 text-white shadow-sm" data-id="element-176" data-mp="18gvplinmx1c1">
          <h2 className="font-heading text-base font-extrabold uppercase leading-tight sm:text-2xl" data-id="element-177" data-mp="uqiex8jcz8j0">
            ⏱️ Less searching. More ready-to-use visual references.
          </h2>
          <p className="mt-1.5 text-[0.86rem] leading-snug text-white/90 sm:text-base" data-id="element-178" data-mp="ks2rpgngcjes">
            Need an OCT pattern reference? It’s ready. Need a fundus comparison?
            It’s ready. Optic nerve, visual fields, corneal maps or multimodal
            patterns? They’re organized too.
          </p>
          <p className="mt-1.5 font-heading text-[0.8rem] font-bold uppercase text-glow" data-id="element-179" data-mp="gq7r6edcia22">
            Open the system. Choose the atlas. Study the pattern.
          </p>
        </article>
      </div>
    </section>;
}